const courseContent = {
  en: {
    categories: {
      removeTag: 'Remove tag: {tag}',
    },
    modules: {
      loadingMessage: 'Loading modules...',
      pageTitle: 'Course modules',
      pageSubtitle: 'Group your lessons into chapters and order the learning path.',
      moduleCount: '{count} modules',
      moduleCountOne: '{count} module',
      addModule: 'Add module',
      loadError: 'Failed to load modules',
      saveError: 'Failed to save module',
      deleteError: 'Failed to delete module',
      reorderError: 'Failed to reorder modules',
      accessDenied: "You don't have access to view these modules.",
      confirmDeleteTitle: 'Delete this module?',
      confirmDeleteHint: 'The module is removed from the course.',
      editModule: 'Edit module',
      newModule: 'New module',
      titleLabel: 'Title',
      titlePlaceholder: 'Module title',
      titleRequired: 'Module title is required',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Module description',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      emptyTitle: 'No modules yet',
      emptyDescription: 'Modules group your lessons into chapters. Create your first one to get started.',
      emptyAction: 'Add module',
      colNumber: '#',
      colModule: 'Module',
      colLessons: 'Lesson count',
      colOrder: 'Order',
      colActions: 'Actions',
      moveUp: 'Move up',
      moveDown: 'Move down',
      edit: 'Edit',
      delete: 'Delete',
    },
    lessons: {
      loadingMessage: 'Loading lessons...',
      pageTitle: 'Lessons',
      lessonCount: '{count} lessons',
      lessonCountOne: '{count} lesson',
      filterAllModules: 'All modules',
      filterNoModule: 'No module',
      filterAriaLabel: 'Filter lessons by module',
      addLesson: 'Add lesson',
      statLessons: 'Lessons',
      statWithVideo: 'With video',
      statTotalDuration: 'Total duration',
      statModules: 'Modules',
      editLesson: 'Edit lesson',
      newLesson: 'New lesson',
      titleLabel: 'Title',
      titlePlaceholder: 'Lesson title',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Lesson description',
      moduleLabel: 'Module',
      noModuleOption: 'No module',
      unnamedModule: 'Unnamed',
      durationLabel: 'Duration (minutes)',
      durationPlaceholder: 'Duration',
      durationVideoHint: 'The video itself is {duration} long. Leave the field blank to always use the video length, or type a number of minutes to override it.',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      loadError: 'Failed to load lessons',
      saveError: 'Failed to save lesson',
      deleteError: 'Failed to delete lesson',
      reorderError: 'Failed to reorder lessons',
      confirmDeleteTitle: 'Delete this lesson?',
      confirmDeleteHint: "The lesson is removed from the course and your students' progress is recalculated.",
      titleFieldLabel: 'Lesson title',
      durationFieldLabel: 'Duration',
      fieldRequired: '{field} is required',
      minLength: '{field} must be at least {min} characters',
      maxLength: '{field} cannot exceed {max} characters',
      durationRange: 'Duration must be between 0 and 10000 minutes',
      noLessonsYet: 'No lessons yet. Create one to get started.',
      noLessonsMatchFilter: 'No lessons match the selected module filter.',
      emptyTitle: 'No lessons yet',
      emptyDescription: 'Add your first lesson to start building this course.',
      emptyFilterTitle: 'No lessons match this filter',
      emptyFilterDescription: 'Try a different module filter or clear it to see every lesson.',
      clearFilter: 'Clear filter',
      durationMinutes: '{count} min',
      accessDenied: "You don't have access to view these lessons.",
      colNumber: '#',
      colOrder: 'Order',
      colLesson: 'Lesson',
      colModule: 'Module',
      colDuration: 'Duration',
      colVideo: 'Video',
      videoStatusUploaded: 'Uploaded',
      videoStatusPending: 'Pending',
      colActions: 'Actions',
      moveUp: 'Move up',
      moveDown: 'Move down',
      noModule: 'No module',
      noModuleTooltip: 'No modules created yet. Add them in Curriculum, under Modules',
      unassigned: 'Unassigned',
      unassignedTooltip: 'Not assigned to a module — edit to assign',
      play: 'Play',
      previewVideoTitle: 'Preview video',
      replace: 'Replace',
      upload: 'Upload',
      edit: 'Edit',
      delete: 'Delete',
      editLessonTitle: 'Edit lesson details',
      moreActions: 'More actions',
      menuAttachVideo: 'Attach video',
      menuReplaceVideo: 'Replace video',
      noVideoUploaded: 'No video uploaded yet.',
      videoNotSupported: 'Your browser does not support video playback.',
      hlsError: 'HLS error: {details}',
      hlsNotSupported: 'HLS not supported in this browser',
      noVideoSource: 'No video source available',
      videoLoadFailed: 'Video load failed',
      videoSourceUnavailable: 'Video storage is unreachable right now. The lesson file could not be read from the server.',
      videoAccessExpired: 'Video access expired. Try again.',
      videoRetry: 'Try again',
    },
  },
  ru: {
    categories: {
      removeTag: 'Удалить тег: {tag}',
    },
    modules: {
      loadingMessage: 'Загрузка модулей...',
      pageTitle: 'Модули курса',
      pageSubtitle: 'Группируйте уроки по главам и выстраивайте порядок обучения.',
      moduleCount: '{count} модулей',
      moduleCountOne: '{count} модуль',
      moduleCountFew: '{count} модуля',
      addModule: 'Добавить модуль',
      loadError: 'Не удалось загрузить модули',
      saveError: 'Не удалось сохранить модуль',
      deleteError: 'Не удалось удалить модуль',
      reorderError: 'Не удалось изменить порядок модулей',
      accessDenied: 'У вас нет доступа для просмотра этих модулей.',
      confirmDeleteTitle: 'Удалить модуль?',
      confirmDeleteHint: 'Модуль будет убран из курса.',
      editModule: 'Редактировать модуль',
      newModule: 'Новый модуль',
      titleLabel: 'Название',
      titlePlaceholder: 'Название модуля',
      titleRequired: 'Название модуля обязательно',
      descriptionLabel: 'Описание',
      descriptionPlaceholder: 'Описание модуля',
      cancel: 'Отмена',
      save: 'Сохранить',
      saving: 'Сохранение...',
      emptyTitle: 'Пока нет модулей',
      emptyDescription: 'Модули группируют уроки по главам. Создайте первый, чтобы начать.',
      emptyAction: 'Добавить модуль',
      colNumber: '#',
      colModule: 'Модуль',
      colLessons: 'Кол-во уроков',
      colOrder: 'Порядок',
      colActions: 'Действия',
      moveUp: 'Переместить вверх',
      moveDown: 'Переместить вниз',
      edit: 'Изменить',
      delete: 'Удалить',
    },
    lessons: {
      loadingMessage: 'Загрузка уроков...',
      pageTitle: 'Уроки',
      lessonCount: '{count} уроков',
      lessonCountOne: '{count} урок',
      lessonCountFew: '{count} урока',
      filterAllModules: 'Все модули',
      filterNoModule: 'Без модуля',
      filterAriaLabel: 'Фильтр уроков по модулю',
      addLesson: 'Добавить урок',
      statLessons: 'Уроки',
      statWithVideo: 'С видео',
      statTotalDuration: 'Общая длительность',
      statModules: 'Модули',
      editLesson: 'Редактировать урок',
      newLesson: 'Новый урок',
      titleLabel: 'Название',
      titlePlaceholder: 'Название урока',
      descriptionLabel: 'Описание',
      descriptionPlaceholder: 'Описание урока',
      moduleLabel: 'Модуль',
      noModuleOption: 'Без модуля',
      unnamedModule: 'Без названия',
      durationLabel: 'Длительность (минуты)',
      durationPlaceholder: 'Длительность',
      durationVideoHint: 'Длительность видео: {duration}. Оставьте поле пустым, чтобы всегда использовать длительность видео, или введите количество минут для её переопределения.',
      cancel: 'Отмена',
      save: 'Сохранить',
      saving: 'Сохранение...',
      loadError: 'Не удалось загрузить уроки',
      saveError: 'Не удалось сохранить урок',
      deleteError: 'Не удалось удалить урок',
      reorderError: 'Не удалось изменить порядок уроков',
      confirmDeleteTitle: 'Удалить урок?',
      confirmDeleteHint: 'Урок будет убран из курса, а прогресс учеников пересчитан.',
      titleFieldLabel: 'Название урока',
      durationFieldLabel: 'Длительность',
      fieldRequired: 'Поле «{field}» обязательно для заполнения',
      minLength: 'Поле «{field}» должно содержать не менее {min} символов',
      maxLength: 'Поле «{field}» не должно превышать {max} символов',
      durationRange: 'Длительность должна быть от 0 до 10000 минут',
      noLessonsYet: 'Пока нет уроков. Создайте первый, чтобы начать.',
      noLessonsMatchFilter: 'Нет уроков, соответствующих выбранному фильтру модуля.',
      emptyTitle: 'Пока нет уроков',
      emptyDescription: 'Добавьте первый урок, чтобы начать наполнять курс.',
      emptyFilterTitle: 'Нет уроков по этому фильтру',
      emptyFilterDescription: 'Попробуйте другой фильтр модуля или сбросьте его, чтобы увидеть все уроки.',
      clearFilter: 'Сбросить фильтр',
      durationMinutes: '{count} мин',
      accessDenied: 'У вас нет доступа для просмотра этих уроков.',
      colNumber: '#',
      colOrder: 'Порядок',
      colLesson: 'Урок',
      colModule: 'Модуль',
      colDuration: 'Длительность',
      colVideo: 'Видео',
      videoStatusUploaded: 'Загружено',
      videoStatusPending: 'Ожидает',
      colActions: 'Действия',
      moveUp: 'Переместить вверх',
      moveDown: 'Переместить вниз',
      noModule: 'Нет модуля',
      noModuleTooltip: 'Модули ещё не созданы. Добавьте их в разделе Программа, на вкладке Модули',
      unassigned: 'Не назначено',
      unassignedTooltip: 'Не привязано к модулю — измените, чтобы назначить',
      play: 'Воспроизвести',
      previewVideoTitle: 'Просмотр видео',
      replace: 'Заменить',
      upload: 'Загрузить',
      edit: 'Изменить',
      delete: 'Удалить',
      editLessonTitle: 'Редактировать данные урока',
      moreActions: 'Другие действия',
      menuAttachVideo: 'Прикрепить видео',
      menuReplaceVideo: 'Заменить видео',
      noVideoUploaded: 'Видео ещё не загружено.',
      videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео.',
      hlsError: 'Ошибка HLS: {details}',
      hlsNotSupported: 'HLS не поддерживается в этом браузере',
      noVideoSource: 'Источник видео недоступен',
      videoLoadFailed: 'Не удалось загрузить видео',
      videoSourceUnavailable: 'Хранилище видео сейчас недоступно. Сервер не смог прочитать файл урока.',
      videoAccessExpired: 'Доступ к видео истёк. Попробуйте снова.',
      videoRetry: 'Повторить',
    },
  },
  uz: {
    categories: {
      removeTag: "Tegni o'chirish: {tag}",
    },
    modules: {
      loadingMessage: 'Modullar yuklanmoqda...',
      pageTitle: 'Kurs modullari',
      pageSubtitle: "Darslaringizni boblarga guruhlang va o'quv yo'lini tartibga soling.",
      moduleCount: '{count} ta modul',
      moduleCountOne: '{count} ta modul',
      addModule: "Modul qo'shish",
      loadError: "Modullarni yuklab bo'lmadi",
      saveError: "Modulni saqlab bo'lmadi",
      deleteError: "Modulni o'chirib bo'lmadi",
      reorderError: "Modullar tartibini o'zgartirib bo'lmadi",
      accessDenied: "Sizda bu modullarni ko'rish uchun ruxsat yo'q.",
      confirmDeleteTitle: "Modulni o'chirasizmi?",
      confirmDeleteHint: "Modul kursdan olib tashlanadi.",
      editModule: 'Modulni tahrirlash',
      newModule: 'Yangi modul',
      titleLabel: 'Nomi',
      titlePlaceholder: 'Modul nomi',
      titleRequired: 'Modul nomini kiritish shart',
      descriptionLabel: 'Tavsif',
      descriptionPlaceholder: 'Modul tavsifi',
      cancel: 'Bekor qilish',
      save: 'Saqlash',
      saving: 'Saqlanmoqda...',
      emptyTitle: "Hozircha modullar yo'q",
      emptyDescription: 'Modullar darslaringizni boblarga guruhlaydi. Boshlash uchun birinchisini yarating.',
      emptyAction: "Modul qo'shish",
      colNumber: '#',
      colModule: 'Modul',
      colLessons: 'Darslar soni',
      colOrder: 'Tartib',
      colActions: 'Amallar',
      moveUp: 'Yuqoriga siljitish',
      moveDown: 'Pastga siljitish',
      edit: 'Tahrirlash',
      delete: "O'chirish",
    },
    lessons: {
      loadingMessage: 'Darslar yuklanmoqda...',
      pageTitle: 'Darslar',
      lessonCount: '{count} ta dars',
      lessonCountOne: '{count} ta dars',
      filterAllModules: 'Barcha modullar',
      filterNoModule: 'Modulsiz',
      filterAriaLabel: "Darslarni modul bo'yicha filtrlash",
      addLesson: "Dars qo'shish",
      statLessons: 'Darslar',
      statWithVideo: 'Video bilan',
      statTotalDuration: 'Umumiy davomiylik',
      statModules: 'Modullar',
      editLesson: 'Darsni tahrirlash',
      newLesson: 'Yangi dars',
      titleLabel: 'Nomi',
      titlePlaceholder: 'Dars nomi',
      descriptionLabel: 'Tavsif',
      descriptionPlaceholder: 'Dars tavsifi',
      moduleLabel: 'Modul',
      noModuleOption: 'Modulsiz',
      unnamedModule: 'Nomsiz',
      durationLabel: 'Davomiyligi (daqiqa)',
      durationPlaceholder: 'Davomiyligi',
      durationVideoHint: "Videoning o'zi {duration} davom etadi. Doim video uzunligidan foydalanish uchun maydonni bo'sh qoldiring yoki uni almashtirish uchun daqiqalar sonini kiriting.",
      cancel: 'Bekor qilish',
      save: 'Saqlash',
      saving: 'Saqlanmoqda...',
      loadError: "Darslarni yuklab bo'lmadi",
      saveError: "Darsni saqlab bo'lmadi",
      deleteError: "Darsni o'chirib bo'lmadi",
      reorderError: "Darslar tartibini o'zgartirib bo'lmadi",
      confirmDeleteTitle: "Darsni o'chirasizmi?",
      confirmDeleteHint: "Dars kursdan olib tashlanadi, o'quvchilar progressi qayta hisoblanadi.",
      titleFieldLabel: 'Dars nomi',
      durationFieldLabel: 'Davomiyligi',
      fieldRequired: "{field} to'ldirilishi shart",
      minLength: "{field} kamida {min} ta belgidan iborat bo'lishi kerak",
      maxLength: "{field} {max} ta belgidan oshmasligi kerak",
      durationRange: "Davomiyligi 0 dan 10000 daqiqagacha bo'lishi kerak",
      noLessonsYet: "Hozircha darslar yo'q. Boshlash uchun birortasini yarating.",
      noLessonsMatchFilter: "Tanlangan modul filtriga mos darslar yo'q.",
      emptyTitle: "Hozircha darslar yo'q",
      emptyDescription: "Kursni to'ldirishni boshlash uchun birinchi darsni qo'shing.",
      emptyFilterTitle: "Bu filtrga mos darslar yo'q",
      emptyFilterDescription: "Boshqa modul filtrini tanlang yoki barcha darslarni ko'rish uchun uni tozalang.",
      clearFilter: 'Filtrni tozalash',
      durationMinutes: '{count} daqiqa',
      accessDenied: "Sizda bu darslarni ko'rish uchun ruxsat yo'q.",
      colNumber: '#',
      colOrder: 'Tartib',
      colLesson: 'Dars',
      colModule: 'Modul',
      colDuration: 'Davomiyligi',
      colVideo: 'Video',
      videoStatusUploaded: 'Yuklangan',
      videoStatusPending: 'Kutilmoqda',
      colActions: 'Amallar',
      moveUp: 'Yuqoriga siljitish',
      moveDown: 'Pastga siljitish',
      noModule: "Modul yo'q",
      noModuleTooltip: "Hali modullar yaratilmagan. Ularni Dastur bo'limidagi Modullar sahifasidan qo'shing",
      unassigned: 'Belgilanmagan',
      unassignedTooltip: 'Modulga biriktirilmagan — belgilash uchun tahrirlang',
      play: 'Ijro etish',
      previewVideoTitle: "Videoni ko'rish",
      replace: 'Almashtirish',
      upload: 'Yuklash',
      edit: 'Tahrirlash',
      delete: "O'chirish",
      editLessonTitle: 'Dars tafsilotlarini tahrirlash',
      moreActions: 'Boshqa amallar',
      menuAttachVideo: 'Video biriktirish',
      menuReplaceVideo: 'Videoni almashtirish',
      noVideoUploaded: 'Hali video yuklanmagan.',
      videoNotSupported: "Brauzeringiz video ijrosini qo'llab-quvvatlamaydi.",
      hlsError: 'HLS xatosi: {details}',
      hlsNotSupported: "Ushbu brauzerda HLS qo'llab-quvvatlanmaydi",
      noVideoSource: 'Video manbasi topilmadi',
      videoLoadFailed: "Videoni yuklab bo'lmadi",
      videoSourceUnavailable: "Video xotirasi hozir mavjud emas. Server dars faylini o'qiy olmadi.",
      videoAccessExpired: 'Videoga ruxsat muddati tugadi. Qayta urinib ko\'ring.',
      videoRetry: 'Qayta urinish',
    },
  },
};

export default courseContent;
